module.exports = __webpack_public_path__ + "static/flc-dbe48d72d0ce994e957fed25a4124495.png";